export const ASSIGN_INCHARGE_REQUEST = 'ASSIGN_INCHARGE_REQUEST'
export const ASSIGN_INCHARGE_SUCCESS = 'ASSIGN_INCHARGE_SUCCESS'
export const ASSIGN_INCHARGE_FALIURE = 'ASSIGN_INCHARGE_FALIURE'
